import { render, staticRenderFns } from "./time-range-format-editor.vue?vue&type=template&id=288e4b9c&scoped=true&"
import script from "./time-range-format-editor.vue?vue&type=script&lang=js&"
export * from "./time-range-format-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288e4b9c",
  null
  
)

export default component.exports